import { fetchLandingCompany } from "../api/action/company";
import { resolveActiveTemplate } from "../api/action/template.jsx";
import { setStoredActiveTemplate } from "../template/TemplateStorage.jsx";
import { createSiteContext, getSiteContextCache, normalizeSiteHost, setSiteContextCache } from "./siteContext";

const normalizeCompanyResponse = (response) => {
  if (Array.isArray(response)) return response[0] || {};
  return response?.data || response || {};
};

export const resolveSiteContext = async ({ dispatch, requestUrl, host }) => {
  const siteHost = normalizeSiteHost(host || requestUrl);
  const cachedContext = getSiteContextCache(siteHost);

  const response = await dispatch(fetchLandingCompany(requestUrl));
  const company = normalizeCompanyResponse(response);
  if (String(company?.status || "").toUpperCase() !== "ACTIVE") {
    throw new Error("Company is not publicly accessible");
  }

  if (!company?.domain?.type && !company?.domainType) {
    throw new Error("Company configuration did not contain a supported domain");
  }

  const domainType = company?.domain?.type || company?.domainType;
  const templateResolution = await resolveActiveTemplate(company.primaryId, domainType, {
    forceRefresh: true,
    siteKey: siteHost,
  });

  if (templateResolution.status === "error") {
    const error = new Error(templateResolution.reason || "Active template resolution failed");
    error.code = "TEMPLATE_RESOLUTION_FAILED";
    throw error;
  }

  const context = createSiteContext({
    host: siteHost,
    company,
    activeTemplate: templateResolution.template,
    templateResolution: {
      ...templateResolution,
      source: "live",
      revalidating: false,
    },
  });

  if (!context) {
    throw new Error("Resolved site configuration failed validation");
  }

  // Compatibility for legacy readers and theme bridges. The scoped SiteContext
  // remains authoritative; this mirror is written only after validation.
  setStoredActiveTemplate(templateResolution.template, { forceStore: true });
  setSiteContextCache(context);
  return { context, cachedContext };
};
